import { SvgIcon, SvgIconProps } from '@mui/material';

const SearchPositioningIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='24' viewBox='0 0 22 24' fill='none'>
        <path d='M5.89062 7L10.7795 7' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M5.89062 16.7778L9.55726 16.7778' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M5.89062 11.8892L13.2239 11.8892' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
        <path
          d='M18.111 10.7779V7.00016C18.111 4.17174 18.111 2.75752 17.2323 1.87884C16.3536 1.00016 14.9394 1.00016 12.111 1.00016H7C4.17157 1.00016 2.75736 1.00016 1.87868 1.87884C1 2.75752 1 4.17174 1 7.00016V17C1 19.8284 1 21.2426 1.87868 22.1213C2.75736 23 4.17157 23 7 23H9.55549'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <circle cx='16.2782' cy='18.7235' r='3.05553' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M20.5557 23.0013L18.7224 21.168' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
      </svg>
    </SvgIcon>
  );
};

export default SearchPositioningIcon;
